import { render } from "./energychart.vue?vue&type=template&id=623426e6"
import script from "./energychart.vue?vue&type=script&lang=js"
export * from "./energychart.vue?vue&type=script&lang=js"

import "./energychart.vue?vue&type=style&index=0&id=623426e6&lang=less"
script.render = render

export default script